@if (isInitialized() && noCards()) {
    <div class="wk-card-view__display-no-info">
        {{ "ViewComponent.NoInfo" | translate }}
    </div>
} @else {
    @if (columns().length > 20) {
        <cdk-virtual-scroll-viewport orientation="horizontal" class="horizontal-viewport">
            <div *cdkVirtualFor="let column of columns(); trackBy: trackByColumnId">
                <column-component
                    [isHidden]="false"
                    [selectedStatus]="selectedStatus()"
                    [selectedStepId]="selectedStepId()"
                    [columnData]="column"
                    [dragDisabled]="dragDisabled()"
                />
            </div>
        </cdk-virtual-scroll-viewport>
    } @else {
        <div class="wk-ac-scroll-container fancy-scrollbar-newUI" cdkScrollable>
            @for (column of columns(); let idx = $index; track trackByColumnId(idx, column)) {
                <column-component [isHidden]="false" [selectedStatus]="selectedStatus()" [selectedStepId]="selectedStepId()" [columnData]="column" />
            }
        </div>
    }
}
